// Edit Code
export const EDIT_CODE_REQUEST = 'EDIT_CODE_REQUEST';
export const EDIT_CODE_DONE = 'EDIT_CODE_DONE';
export const EDIT_CODE_FAILED = 'EDIT_CODE_FAILED';
export const EDIT_CODE_RESET = 'EDIT_CODE_RESET';